import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import '@coreui/coreui/dist/css/coreui.min.css'
const rootElement = document.getElementById("simulation-root")
ReactDOM.createRoot(rootElement).render(<App />)
